var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextWithLinksStep',{attrs:{"title":_vm.$t('settings.automation.whenIWork.trainTeam.title'),"sections":_vm.$t('settings.automation.whenIWork.trainTeam.sections')}})
}
var staticRenderFns = []

export { render, staticRenderFns }